const TransferToFundReason = ['TAF', 'TBPO', 'TBB', 'TBSER', 'TPROM', 'TLP', 'THEAL', 'TCP'];

export default TransferToFundReason;
